import React from 'react';
import UserAdminPage from './pages/UserAdminPage';
import ProviderAdminPage from './pages/ProviderAdminPage';
import ReviewModerationPage from './pages/ReviewModerationPage';
import ServiceRequestAdminPage from './pages/ServiceRequestAdminPage';
import AdminReportListPage from './pages/AdminReportListPage';
import AdminReportPage from './pages/AdminReportPage';
import { Route } from 'react-router-dom';

// modules return fragments containing routes.
// passing the component as a prop ensures match params are passed in props
// see https://stackoverflow.com/questions/46197178/cannot-read-property-params-of-undefined-react-router-4

const routes = () => {
  return [
    <Route key="/siteadmin/user" exact={false} path="/siteadmin/user/:type?/:uuid?" component={UserAdminPage} />,
    <Route key="/siteadmin/reviewmoderation" exact={false} path="/siteadmin/reviewmoderation" component={ReviewModerationPage} />,
    <Route key="/siteadmin/provider" exact={false} path="/siteadmin/provider" component={ProviderAdminPage} />,
    <Route key="/siteadmin/servicerequest" exact={false} path="/siteadmin/servicerequest" component={ServiceRequestAdminPage} />,
    <Route key="/siteadmin/reports" exact={true} path="/siteadmin/reports" component={AdminReportListPage} />,
    <Route key="/siteadmin/reports" exact={true} path="/siteadmin/reports/:reportName?" component={AdminReportPage} />,

  ];
};

export default routes;
